import { useContext } from 'react';
import { CallIncomingContext } from 'contexts/call_incoming_context';

const useCallIncoming = () => {
    return useContext(CallIncomingContext);
};

export default useCallIncoming;
